"use client";

import { useSidebar } from "@/components/ui/sidebar";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import CarTrackedLogo from "@/components/images/cartracked-test";
import { UserButton } from "@clerk/nextjs";
import { IconBell } from "@tabler/icons-react";
import { PanelLeft } from "lucide-react";

export function Header() {
  const { isMobile, setOpenMobile, toggleSidebar } = useSidebar();

  return (
    <header className="sticky top-0 z-10 flex h-16 shrink-0 items-center gap-2 border-b bg-background px-4 transition-[width,height] ease-linear group-has-data-[collapsible=icon]/sidebar-wrapper:h-12">
      <div className="flex items-center gap-2">
        <Button
          variant="ghost"
          size="icon"
          className="h-7 w-7 -ml-1"
          onClick={() => (isMobile ? setOpenMobile(true) : toggleSidebar())}
        >
          <PanelLeft className="h-4 w-4" />
          <span className="sr-only">Toggle navigation</span>
        </Button>
        <Separator orientation="vertical" className="h-6" />
        <CarTrackedLogo className="h-4 w-auto" />
      </div>

      <div className="flex flex-1 items-center justify-between gap-4">
        <div className="flex-1 max-w-md" />

        <div className="flex items-center gap-2">
          <DropdownMenu>
            <DropdownMenuTrigger asChild>
              <Button variant="ghost" size="sm" className="gap-2">
                <IconBell className="size-4" />
              </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end" className="w-48">
              <DropdownMenuItem>
                <span>No new notifications</span>
              </DropdownMenuItem>
            </DropdownMenuContent>
          </DropdownMenu>

          <Separator orientation="vertical" className="h-6" />
          <UserButton />
        </div>
      </div>
    </header>
  );
}
